import { render } from "./SpacesGroupsYouOwn.vue?vue&type=template&id=67c09371&scoped=true&ts=true"
import script from "./SpacesGroupsYouOwn.vue?vue&type=script&lang=ts"
export * from "./SpacesGroupsYouOwn.vue?vue&type=script&lang=ts"

import "./SpacesGroupsYouOwn.vue?vue&type=style&index=0&id=67c09371&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c09371"]])

export default __exports__